<template>
  <footer class="shell-footer">
    <v-sheet color="primary" class="position-relative">
      <v-container class="py-6">
        <div class="grid-list">
          <div class="grid-list-item">
            <router-link to="/">
              <img
                v-if="informations.img"
                :src="files + informations.img"
                :alt="informations.name"
                height="40px"
                class="d-block mx-auto mx-md-0 filter-white"
              />
            </router-link>
          </div>

          <div class="d-flex flex-column align-start grid-list-item">
            <template v-for="{ text, to } in menu">
              <v-btn
                :key="text"
                class="
                  white--text
                  text-body-2 text-none text-uppercase
                  font-weight-regular
                  btn-contact
                "
                color="transparent"
                :to="to"
                height="28px"
                depressed
              >
                {{ text }}
              </v-btn>
            </template>

            <v-sheet
              v-if="informations.creci"
              class="
                d-flex
                align-center
                white--text
                text-body-2 text-none text-uppercase
                font-weight-medium
                px-4
                btn-contact
              "
              color="transparent"
              height="28px"
              depressed
            >
              CRECI: {{ informations.creci }}
            </v-sheet>

            <v-sheet
              v-if="informations.cnpj"
              class="
                d-flex
                align-center
                white--text
                text-body-2 text-none text-uppercase
                font-weight-medium
                px-4
                btn-contact
              "
              color="transparent"
              height="28px"
              depressed
            >
              CNPJ: {{ informations.cnpj }}
            </v-sheet>
          </div>

          <div class="d-flex flex-column align-start grid-list-item">
            <div
              v-for="{
                name,
                text,
                link,
                target,
                icon,
                size,
                keyContact,
              } in contacts"
              :key="keyContact"
            >
              <v-btn
                class="white--text text-body-2 text-none btn-contact"
                height="auto"
                min-height="36px"
                :href="link"
                :target="target"
                :title="name"
                depressed
                color="transparent"
              >
                <v-icon v-if="icon" :size="size" class="mr-2">
                  {{ icon }}
                </v-icon>

                <span v-html="text"></span>
              </v-btn>
            </div>
          </div>

          <div class="grid-list-item">
            <div
              v-for="({ text, link, icon }, keySocial) in social"
              :key="keySocial"
              class="d-flex align-center"
              :class="{ 'mt-2': keySocial > 0 }"
            >
              <v-btn
                class="
                  white--text
                  text-caption text-lg-body-1 text-none
                  font-weight-regular
                  pl-0
                  ml-2
                  btn-social
                "
                color="transparent"
                :href="link"
                target="_blank"
                :title="text"
                height="30px"
                depressed
                rounded
                small
              >
                <v-sheet
                  class="
                    d-flex
                    align-center
                    justify-center
                    rounded-circle
                    mr-2
                    btn-social-icon
                  "
                  color="transparent"
                  width="30px"
                  height="30px"
                >
                  <v-icon color="white" size="14">{{ icon }}</v-icon>
                </v-sheet>

                {{ getUserName(link, text) }}
              </v-btn>
            </div>
          </div>

          <div v-if="informations.address" class="grid-list-item">
            <v-btn
              class="text-body-1 text-none font-weight-regular btn-contact"
              :href="informations.google_maps"
              target="_blank"
              color="white"
              text
            >
              <v-icon size="18" left> fa-map-marker-alt </v-icon>
              {{ informations.address }}
            </v-btn>
          </div>
        </div>
      </v-container>

      <v-container class="py-0">
        <v-sheet
          color="rgba(255, 255, 255, 0.10)"
          width="100%"
          height="1px"
        ></v-sheet>
      </v-container>

      <v-container
        class="
          d-flex
          flex-column flex-sm-row
          justify-space-between
          align-center
          text-center
          pt-0
          pb-5
        "
      >
        <div class="white--text text-body-1 font-weight-regular mt-5">
          <b>{{ informations.name }}</b>
          © {{ year }}.
          <span class="d-block d-sm-inline-block">
            Todos os direitos reservados.
          </span>
        </div>
        <a
          class="d-flex mt-5"
          href="https://www.mrxweb.com.br/"
          target="_blank"
        >
          <img
            class="shell-footer-logo"
            src="../../assets/img/mrxweb.svg"
            alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
            height="20px"
          />
        </a>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getContact } from "../../utils/getContact";
import { getSocial } from "../../utils/getSocial";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    contacts() {
      return getContact({
        tel: this.informations.tel,
        whatsapp: this.informations.whatsapp,
      });
    },
    social() {
      return getSocial({
        facebook: this.informations.facebook,
        instagram: this.informations.instagram,
      }).reverse();
    },
    menu() {
      return [
        {
          text: "Sobre",
          to: "/sobre",
        },
        {
          text: "Cadastre seu Imóvel",
          to: "/cadastre-seu-imovel",
        },
        {
          text: "Política de Privacidade",
          to: "/politica-de-privacidade",
        },
      ];
    },
  },
  methods: {
    getUserName(link, name) {
      var user = "";

      switch (name) {
        case "Instagram":
          user += "@";
          break;
        case "Facebook":
          user += "/";
          break;
      }

      if (/https?:\/\//.test(link)) {
        user += new URL(link).pathname.split("/")[1];
      }

      return user;
    },
  },
};
</script>

<style lang="scss" scoped>
.shell-footer {
  .grid-list {
    display: grid;
    gap: 24px 48px;
    grid-template-columns: auto 1fr 1fr 1fr;
    justify-content: space-between;

    &-item:last-child {
      grid-column: 2 /-1;
    }

    @media screen and (min-width: 600px) and (max-width: 959.9px) {
      gap: 24px;
      grid-template-columns: auto auto;

      &-item:first-child,
      &-item:last-child {
        grid-column: 1 / -1;
      }
    }

    @media screen and (max-width: 959.9px) {
      &-item:last-child {
        grid-column: 1 /-1;
      }
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
      justify-content: center;
    }

    .btn-contact::v-deep {
      .v-btn__content {
        max-width: 100%;
        white-space: normal;
      }
    }
  }
}

.btn-social {
  &-icon {
    border: 1px solid #ffffff !important;
  }
}
</style>
